import React from 'react'

function Footer() {
  return (
    <footer id="fifty-footer">
        <div className="row">
            <div className="container">
                <div className="copyright-container-wrap wow zoomIn">
                    <p> © 2025 <a href="index.html"> Snapshot Videos </a> - All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer